import { usePlatformPageTracking } from "@/hooks/usePlatformPageTracking";

export function AppTelemetry() {
  usePlatformPageTracking();
  return null;
}